import { useQuery } from "@tanstack/react-query";
import { companySessionsQueryOptions } from "./queries";
import { CompanyLiveRow } from "./CompanyLiveRow";

const LIMIT = 5;

export function CompanyAttention() {
  const { data = [], isLoading } = useQuery(
    companySessionsQueryOptions("awaiting", LIMIT),
  );

  return (
    <section>
      <h2 className="company-section-title">
        Требуют решения
        <span className="company-count-chip">{data.length}</span>
      </h2>
      <div className="company-live-card">
        {isLoading ? (
          <div className="cmd-empty">Загрузка…</div>
        ) : data.length === 0 ? (
          <div className="cmd-empty">
            <p className="cmd-empty-title">Всё под контролем</p>
            <p className="cmd-empty-hint">
              Сейчас ни одна задача не ждёт ответа.
            </p>
          </div>
        ) : (
          <div className="company-live-list">
            {data.map((s) => (
              <CompanyLiveRow key={s.id} session={s} />
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
